import { useMemo } from "react";
import styled from "@emotion/styled";
import { WrappingQuoteHeader } from "./elements/WrappingQuoteHeader";
import { WrappingQuoteCompleted } from "./sections/WrappingQuoteCompleted";
import { WrappingQuoteInitial } from "./sections/WrappingQuoteInitial";
import { GlobalStore } from "../../store/global/GlobalStore";
import { WrapQuoteStatus } from "../../types/wrapQuote";
import { motion } from "framer-motion";

export const WrappingQuote: React.FC = () => {
  const wrapQuoteStatus = GlobalStore.useState(s => s.wrapQuoteStatus);
  const WrapContent = useMemo(() => {
    if (wrapQuoteStatus !== WrapQuoteStatus.COMPLETED) {
      return <WrappingQuoteInitial />;
    }
    return <WrappingQuoteCompleted />;
  }, [wrapQuoteStatus]);

  return (
    <WrappingQuoteContainer initial={"initial"} variants={slideVariants} animate={"slide"}>
      {wrapQuoteStatus !== WrapQuoteStatus.COMPLETED && <WrappingQuoteHeader />}
      <ContentWrapper>{WrapContent}</ContentWrapper>
    </WrappingQuoteContainer>
  );
};

const slideVariants = {
  initial: { x: -20 },
  slide: { x: 0 },
};
export const ContentWrapper = styled.div`
  display: flex;
  padding: 0px 26px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
`;
export const WrappingQuoteContainer = styled(motion.div)`
  min-height: 462px;
  display: flex;
  flex-direction: column;
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const LearnMoreLink = styled.a`
  color: #38da7c;
`;
